function lang() {
  return navigator.language;
}

export enum MonthFormat {
  NUMERIC = 'numeric',
  TWO_DIGITS = '2-digit',
  LONG = 'long',
  SHORT = 'short',
  NARROW = 'narrow',
}
export function months(format: MonthFormat = MonthFormat.LONG) {
  const formatter = new Intl.DateTimeFormat(lang(), {month: format});
  return new Array(12).fill(0).map((_, i) => formatter.format(new Date(1970, i, 1)));
}

export interface TimeFilterValue {
  from?: number | null;
  to?: number | null;
}

export const timeFrameDefaultValue: Readonly<TimeFilterValue> = {
  from: null,
  to: null,
};

export function getReadableDuration(startDate: Date, endDate: Date): string {
  if (!startDate || !endDate) {
    return '';
  }
  const dates = {
    startDate,
    endDate,
  };
  const sameMonth = dates.startDate.getMonth() === dates.endDate.getMonth();
  const sameYear = dates.startDate.getFullYear() === dates.endDate.getFullYear();

  if (dates.startDate.valueOf() === dates.endDate.valueOf()) {
    return `${months()[dates.startDate.getMonth()]} ${dates.startDate.getDate()}, ${dates.startDate.getFullYear()}`;
  }

  if (sameMonth && sameYear) {
    return `${
      months()[dates.startDate.getMonth()]
    } ${dates.startDate.getDate()} - ${dates.endDate.getDate()}, ${dates.startDate.getFullYear()}`;
  }
  if (sameYear) {
    return `${months()[dates.startDate.getMonth()]} ${dates.startDate.getDate()} - ${
      months()[dates.endDate.getMonth()]
    } ${dates.endDate.getDate()}, ${dates.startDate.getFullYear()}`;
  }

  return `${months()[dates.startDate.getMonth()]} ${dates.startDate.getDate()}, ${dates.startDate.getFullYear()} - ${
    months()[dates.endDate.getMonth()]
  } ${dates.endDate.getDate()}, ${dates.endDate.getFullYear()}`;
}

export function formatTimeFrameValue(commonTimeFrame: TimeFilterValue = timeFrameDefaultValue) {
  const {from, to} = commonTimeFrame;
  if (!!from && !!to) {
    return getReadableDuration(new Date(from), new Date(to));
  }
  return 'Timeframe';
}
